import {Component, OnChanges, Input} from '@angular/core';

@Component({
    selector: 'error',
    template: `        
        <div class="alert-danger alert" [ngClass]="{'static-error':type==='static'}" *ngIf="message">
            <p [innerHTML]="message"></p>
            <i class="icon glyph-close" (click)="closeMessage()"></i>
        </div>
    `,

})

export class ErrorComponent implements OnChanges{

    @Input() message: string;
    @Input() type: string;

    closeMessage(){
        this.message = '';
    }

    ngOnChanges(){

    }
}